/**
 * PDP Media Click Handler
 * Adds click event listeners to images and videos in specific sections
 * Triggers alert when user clicks on media elements
 */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Minimum screen width for this functionality to be active
  const MIN_SCREEN_WIDTH = 1024;

  // Define the selectors for media elements in different sections
  const mediaSelectors = [
    // Hero images section
    '.hero-images img',
    '.hero-images video',

    // Single image section
    '.single-image img',
    '.single-image video',

    // Other images grid section
    '.pdp-other-images .image-grid img',
    '.pdp-other-images .image-grid video',

    // Size slider section (after slider loads)
    '.size-slider .size-slider-slide-media img',
    '.size-slider .size-slider-slide-media video'
  ];

  // Data attribute to mark elements that already have handlers
  const HANDLER_ATTACHED_ATTR = 'data-click-handler-attached';

  /**
   * Check if screen width meets minimum requirement
   */
  function isScreenWidthValid() {
    return window.innerWidth >= MIN_SCREEN_WIDTH;
  }

  /**
   * Initialize click handlers for all media elements
   */
  function initMediaClickHandlers() {
    // Only run on screens 1024px and above
    if (!isScreenWidthValid()) {
      console.log('Screen width below 1024px, skipping media click handlers');
      return;
    }
    // Combine all selectors and query all matching elements
    const allMediaElements = document.querySelectorAll(mediaSelectors.join(', '));

    console.log(`Found ${allMediaElements.length} media elements to attach click handlers`);

    // Add click event listener to each media element
    allMediaElements.forEach(function(mediaElement) {
      // Skip if handler already attached
      if (mediaElement.hasAttribute(HANDLER_ATTACHED_ATTR)) {
        return;
      }

      // Mark as having handler attached
      mediaElement.setAttribute(HANDLER_ATTACHED_ATTR, 'true');
      mediaElement.style.cursor = 'pointer'; // Make it obvious it's clickable

      mediaElement.addEventListener('click', function(event) {
        // Extract image src for gallery scroll sync
        // For <img> elements, use currentSrc (respects srcset) or fall back to src
        // For <video> elements, pass null so gallery opens at top
        var imageSrc = null;
        if (mediaElement.tagName === 'IMG') {
          imageSrc = mediaElement.currentSrc || mediaElement.src || null;
        }

        // Open the gallery popup, scrolled to the matching image
        openGallery(imageSrc);
      });
    });
  }


  /**
   * Re-initialize handlers after dynamic content loads (e.g., size slider)
   * This function can be called after Splide initialization
   */
  function reinitHandlers() {
    initMediaClickHandlers();
  }

  // Initial setup
  initMediaClickHandlers();

  // Re-initialize after a delay to catch dynamically loaded content (size slider)
  setTimeout(function() {
    initMediaClickHandlers();
  }, 1000);

  // Also re-initialize when window is fully loaded
  window.addEventListener('load', function() {
    setTimeout(function() {
      initMediaClickHandlers();
    }, 500);
  });

  // Expose reinit function globally for manual triggering if needed
  window.pdpMediaClickHandler = {
    reinit: reinitHandlers
  };
});
